export default __webpack_public_path__ + "static/AlecEmpire_AtariTeenageRiot-f7046a3a2754e37ca7fd9f7fc5898d41.jpg";